import type { ModelDefinition } from "@/models.js";

export const anthropicModels = [
	{
		id: "claude-fable-5",
		name: "Claude Fable 5",
		description: "Next generation intelligence for knowledge work and coding.",
		family: "anthropic",
		releasedAt: new Date("2026-06-09"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-fable-5",
				deactivatedAt: new Date("2026-06-13"),
				inputPrice: "10.0e-6",
				outputPrice: "50.0e-6",
				cachedInputPrice: "1.0e-6",
				cacheWriteInputPrice: "12.5e-6",
				cacheWriteInputPrice1h: "20.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-fable-5",
				deactivatedAt: new Date("2026-06-13"),
				inputPrice: "10.0e-6",
				outputPrice: "50.0e-6",
				cachedInputPrice: "1.0e-6",
				cacheWriteInputPrice: "12.5e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
			},
		],
	},
	{
		id: "claude-3-7-sonnet",
		name: "Claude 3.7 Sonnet",
		description:
			"Intelligent model with extended thinking for complex reasoning tasks.",
		family: "anthropic",
		releasedAt: new Date("2025-02-24"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-7-sonnet-latest",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-3-7-sonnet-20250219-v1:0",
				deprecatedAt: new Date("2025-10-28"),
				deactivatedAt: new Date("2026-04-28"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-3-5-haiku-20241022",
		name: "Claude 3.5 Haiku (2024-10-22)",
		description:
			"Fast, compact model for quick responses and efficient processing.",
		family: "anthropic",
		releasedAt: new Date("2024-10-22"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-3-5-haiku-20241022",
				inputPrice: "0.8e-6",
				outputPrice: "4.0e-6",
				cachedInputPrice: "0.08e-6",
				cacheWriteInputPrice: "1.0e-6",
				cacheWriteInputPrice1h: "1.6e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
				deprecatedAt: new Date("2025-12-19"),
				deactivatedAt: new Date("2026-02-19T17:00:00Z"),
			},
		],
	},
	{
		id: "claude-3-7-sonnet-20250219",
		name: "Claude 3.7 Sonnet (2025-02-19)",
		description:
			"Dated version of Claude 3.7 Sonnet with reasoning capabilities.",
		family: "anthropic",
		releasedAt: new Date("2025-02-19"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-7-sonnet-20250219",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: false,
				reasoning: true,
				reasoningMaxTokens: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
		],
	},
	{
		id: "claude-3-5-sonnet-20241022",
		name: "Claude 3.5 Sonnet (2024-10-22)",
		description: "Previous generation Sonnet model for balanced performance.",
		family: "anthropic",
		releasedAt: new Date("2024-10-22"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-5-sonnet-20241022",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
				deactivatedAt: new Date("2025-10-28"),
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-3-5-sonnet-20241022-v2:0",
				deprecatedAt: new Date("2025-10-28"),
				deactivatedAt: new Date("2026-04-28"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-2.1",
		name: "Claude 2.1",
		description: "Legacy Claude model, deprecated in 2025.",
		family: "anthropic",
		releasedAt: new Date("2023-11-21"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-2.1",
				inputPrice: "8.0e-6",
				outputPrice: "24.0e-6",
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: false,
				deprecatedAt: new Date("2025-06-15T00:00:00Z"),
				deactivatedAt: new Date("2025-07-21T16:00:00Z"),
			},
		],
	},
	{
		id: "claude-sonnet-4-20250514",
		name: "Claude Sonnet 4 (2025-05-14)",
		description: "Claude Sonnet 4 with enhanced reasoning and tool use.",
		family: "anthropic",
		releasedAt: new Date("2025-05-14"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-sonnet-4-20250514",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-sonnet-4-20250514-v1:0",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-sonnet-4-5",
		name: "Claude Sonnet 4.5",
		description:
			"Latest Claude Sonnet with improved reasoning and extended thinking.",
		family: "anthropic",
		releasedAt: new Date("2025-09-29"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-sonnet-4-5",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				reasoning: true,
				reasoningMaxTokens: true,
				maxOutput: 64000,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-sonnet-4-5-20250929-v1:0",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
			},
			{
				test: "skip",
				providerId: "vertex-anthropic",
				externalId: "claude-sonnet-4-5",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-sonnet-4-5-20250929",
		name: "Claude Sonnet 4.5 (2025-09-29)",
		description:
			"Latest Claude Sonnet with improved reasoning and extended thinking.",
		family: "anthropic",
		releasedAt: new Date("2025-09-29"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-sonnet-4-5-20250929",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				reasoning: true,
				reasoningMaxTokens: true,
				maxOutput: 64000,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-sonnet-4-5-20250929-v1:0",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-sonnet-4-6",
		name: "Claude Sonnet 4.6",
		description:
			"Claude Sonnet 4.6 with advanced reasoning, extended thinking, and vision capabilities.",
		family: "anthropic",
		releasedAt: new Date("2026-02-17"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-sonnet-4-6",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 64000,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-sonnet-4-6",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 64000,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
			},
			{
				providerId: "vertex-anthropic",
				externalId: "claude-sonnet-4-6",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 64000,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-haiku-4-5",
		name: "Claude Haiku 4.5",
		description:
			"Fast, efficient model for high-volume, low-latency applications.",
		family: "anthropic",
		releasedAt: new Date("2025-10-15"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-haiku-4-5",
				inputPrice: "1.0e-6",
				outputPrice: "5.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "1.25e-6",
				cacheWriteInputPrice1h: "2.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-haiku-4-5-20251001-v1:0",
				inputPrice: "1.0e-6",
				outputPrice: "5.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "1.25e-6",
				cacheWriteInputPrice1h: "2.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
				regions: [{ id: "global" }, { id: "us" }, { id: "eu" }, { id: "apac" }],
			},
			{
				providerId: "vertex-anthropic",
				externalId: "claude-haiku-4-5",
				inputPrice: "1.0e-6",
				outputPrice: "5.0e-6",
				cachedInputPrice: "0.1e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-haiku-4-5-20251001",
		name: "Claude Haiku 4.5 (2025-10-01)",
		description:
			"Fast, efficient model for high-volume, low-latency applications.",
		family: "anthropic",
		releasedAt: new Date("2025-10-15"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-haiku-4-5-20251001",
				inputPrice: "1.0e-6",
				outputPrice: "5.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "1.25e-6",
				cacheWriteInputPrice1h: "2.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-haiku-4-5-20251001-v1:0",
				inputPrice: "1.0e-6",
				outputPrice: "5.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "1.25e-6",
				cacheWriteInputPrice1h: "2.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-opus-4-20250514",
		name: "Claude Opus 4 (2025-05-14)",
		description:
			"High-capability model for complex analysis and nuanced tasks.",
		family: "anthropic",
		releasedAt: new Date("2025-05-22"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-opus-4-20250514",
				inputPrice: "15.0e-6",
				outputPrice: "75.0e-6",
				cachedInputPrice: "1.5e-6",
				cacheWriteInputPrice: "18.75e-6",
				cacheWriteInputPrice1h: "30.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-20250514-v1:0",
				inputPrice: "15.0e-6",
				outputPrice: "75.0e-6",
				cachedInputPrice: "1.5e-6",
				cacheWriteInputPrice: "18.75e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-opus-4-1-20250805",
		name: "Claude Opus 4.1",
		description: "Updated Opus with vision support and 32K output.",
		family: "anthropic",
		releasedAt: new Date("2025-08-05"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-opus-4-1-20250805",
				inputPrice: "15.0e-6",
				outputPrice: "75.0e-6",
				cachedInputPrice: "1.5e-6",
				cacheWriteInputPrice: "18.75e-6",
				cacheWriteInputPrice1h: "30.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 32000,
				streaming: true,
				vision: true,
				reasoning: true,
				reasoningMaxTokens: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-1-20250805-v1:0",
				inputPrice: "15.0e-6",
				outputPrice: "75.0e-6",
				cachedInputPrice: "1.5e-6",
				cacheWriteInputPrice: "18.75e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 32000,
				streaming: true,
				vision: true,
				reasoning: true,
				reasoningMaxTokens: true,
				tools: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-3-5-sonnet-20240620",
		name: "Claude 3.5 Sonnet (Old)",
		description: "Original Claude 3.5 Sonnet with vision capabilities.",
		family: "anthropic",
		releasedAt: new Date("2024-06-20"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-5-sonnet-20240620",
				deactivatedAt: new Date("2025-10-28"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: true,
				tools: true,
			},
		],
	},
	{
		id: "claude-3-5-sonnet",
		name: "Claude 3.5 Sonnet",
		description:
			"Latest Claude 3.5 Sonnet with balanced speed and intelligence.",
		family: "anthropic",
		releasedAt: new Date("2024-06-20"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-5-sonnet-latest",
				deactivatedAt: new Date("2025-10-28"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
		],
	},
	{
		id: "claude-3-5-haiku",
		name: "Claude 3.5 Haiku",
		description: "Fastest Claude model for instant responses at scale.",
		family: "anthropic",
		releasedAt: new Date("2024-10-22"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-3-5-haiku-latest",
				inputPrice: "0.8e-6",
				outputPrice: "4.0e-6",
				cachedInputPrice: "0.08e-6",
				cacheWriteInputPrice: "1.0e-6",
				cacheWriteInputPrice1h: "1.6e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
				deprecatedAt: new Date("2025-12-19"),
				deactivatedAt: new Date("2026-02-19T17:00:00Z"),
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-3-5-haiku-20241022-v1:0",
				deprecatedAt: new Date("2025-10-28"),
				deactivatedAt: new Date("2026-04-28"),
				inputPrice: "0.8e-6",
				outputPrice: "4.0e-6",
				cachedInputPrice: "0.08e-6",
				cacheWriteInputPrice: "1.0e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-3-opus",
		name: "Claude 3 Opus",
		description: "Most capable Claude 3 model for expert-level tasks.",
		family: "anthropic",
		releasedAt: new Date("2024-03-04"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-opus-20240229",
				inputPrice: "15.0e-6",
				outputPrice: "75.0e-6",
				cachedInputPrice: "1.5e-6",
				cacheWriteInputPrice: "18.75e-6",
				cacheWriteInputPrice1h: "30.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 4096,
				streaming: true,
				vision: true,
				tools: true,
			},
		],
	},
	{
		id: "claude-3-haiku",
		name: "Claude 3 Haiku",
		description:
			"Compact Claude 3 model with vision for fast, affordable inference.",
		family: "anthropic",
		releasedAt: new Date("2024-03-04"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-3-haiku-20240307",
				inputPrice: "0.25e-6",
				outputPrice: "1.25e-6",
				cachedInputPrice: "0.03e-6",
				cacheWriteInputPrice: "0.3e-6",
				cacheWriteInputPrice1h: "0.5e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 4096,
				streaming: true,
				vision: true,
				tools: true,
				deprecatedAt: new Date("2025-07-14"),
				deactivatedAt: new Date("2025-10-14"),
			},
		],
	},
	{
		id: "claude-3-haiku-20240307",
		name: "Claude 3 Haiku (2024-03-07)",
		description:
			"Compact Claude 3 model with vision for fast, affordable inference.",
		family: "anthropic",
		releasedAt: new Date("2024-03-04"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-3-haiku-20240307",
				inputPrice: "0.25e-6",
				outputPrice: "1.25e-6",
				cachedInputPrice: "0.03e-6",
				cacheWriteInputPrice: "0.3e-6",
				cacheWriteInputPrice1h: "0.5e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 4096,
				streaming: true,
				vision: true,
				tools: true,
				deprecatedAt: new Date("2025-07-14"),
				deactivatedAt: new Date("2025-10-14"),
			},
		],
	},
	{
		id: "claude-opus-4-5-20251101",
		name: "Claude Opus 4.5",
		description:
			"Claude Opus 4.5 is Anthropic's advanced reasoning model built for complex coding, agentic workflows, and long-running tasks with improved multimodal performance, efficiency, and reliability.",
		family: "anthropic",
		releasedAt: new Date("2025-11-24"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-opus-4-5-20251101",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 32000,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-5-20251101-v1:0",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 32000,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
			},
			{
				test: "skip",
				providerId: "vertex-anthropic",
				externalId: "claude-opus-4-5",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 32000,
				reasoning: true,
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
			},
		],
	},
	{
		id: "claude-opus-4-6",
		name: "Claude Opus 4.6",
		description:
			"Claude Opus 4.6 is Anthropic's latest flagship model with advanced reasoning capabilities for complex coding, agentic workflows, and long-running tasks.",
		family: "anthropic",
		releasedAt: new Date("2026-02-05"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-opus-4-6",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-6-v1",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
			},
			{
				test: "skip",
				providerId: "vertex-anthropic",
				externalId: "claude-opus-4-6",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
			},
		],
	},
	{
		id: "claude-opus-4-7",
		name: "Claude Opus 4.7",
		description:
			"Claude Opus 4.7 is Anthropic's latest flagship model with enhanced coding and vision capabilities, adaptive reasoning, and improved performance on complex agentic workflows.",
		family: "anthropic",
		releasedAt: new Date("2026-04-16"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-opus-4-7",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningMode: "adaptive",
				// Adaptive thinking may skip thinking for simpler prompts, so reasoning content
				// is not guaranteed in every response.
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-7",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
			},
			{
				providerId: "vertex-anthropic",
				externalId: "claude-opus-4-7",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
			},
		],
	},
	{
		id: "claude-opus-4-8",
		name: "Claude Opus 4.8",
		description:
			"Claude Opus 4.8 is Anthropic's most capable model with state-of-the-art coding, reasoning, and agentic capabilities.",
		family: "anthropic",
		releasedAt: new Date("2026-05-28"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-opus-4-8",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
				webSearch: true,
				webSearchPrice: "0.01",
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-8",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
			},
		],
	},
] as const satisfies ModelDefinition[];
